import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useParams, useNavigate, Link } from "react-router-dom";
import { getCareerEnquiries, getCareers } from "../Apis/CareerAPIs";
import { getImageUrl } from "../Apis/api";
import usePermissions from "../hook/userPermission";

const CareerEnquiryLayer = () => {
  const { hasPermission } = usePermissions();
  const { id } = useParams();
  const navigate = useNavigate();
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [jobTitle, setJobTitle] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetchEnquiries();
    fetchJobDetails();
  }, [id]);

  const fetchEnquiries = async () => {
    setLoading(true);
    const res = await getCareerEnquiries(id);
    if (res.status) {
      setEnquiries(res.response?.data || res.response || []);
    }
    setLoading(false);
  };

  const fetchJobDetails = async () => {
    const res = await getCareers();
    if (res.status) {
      const data = res.response?.data || res.response;
      const job = data.find(c => (c._id || c.id) === id);
      if (job) setJobTitle(job.jobRole);
    }
  };

  const formatPrice = (price) => {
    if (!price) return "N/A";
    const num = parseFloat(price.toString().replace(/,/g, ""));
    if (isNaN(num)) return price;
    return num.toLocaleString("en-IN");
  };

  const filteredEnquiries = enquiries.filter(enq => 
    enq.fullName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    enq.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    enq.mobileNo?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="card h-100 p-0 radius-12 overflow-hidden border-0 shadow-sm">
      <div
        className="card-header border-bottom py-16 px-24 d-flex align-items-center justify-content-between flex-wrap gap-3"
        style={{ background: "linear-gradient(135deg, #000000, #bb0007, #ed1c24)" }}
      >
        <div className="d-flex align-items-center gap-3">
            <h6 className="text-white mb-0 fw-bold">{jobTitle || "Job Role"}</h6>
            <span className="text-white opacity-50">|</span>
            <h6 className="text-white mb-0 fw-bold">Candidate Enquiries</h6>
        </div>

        <div className="d-flex align-items-center gap-3 flex-grow-1 justify-content-end">
            <div className="position-relative w-100" style={{ maxWidth: "300px" }}>
                <input
                    type="text"
                    className="form-control radius-8 ps-40 py-8 bg-white border-0"
                    placeholder="Search candidate..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ height: "40px" }}
                />
                <Icon
                    icon="solar:magnifer-linear"
                    className="position-absolute text-secondary-light"
                    style={{ left: "12px", top: "50%", transform: "translateY(-50%)", fontSize: "18px" }}
                />
            </div>
             <Link
                to="/careers"
                className="btn btn-sm d-flex align-items-center gap-1"
                style={{
                  backgroundColor: "#f7e7da",
                  color: "black",
                  fontWeight: "600",
                }}
              >
                <Icon icon="solar:arrow-left-bold" /> Back to Careers
              </Link>
        </div>
      </div>

      <div className="card-body p-24">
        <div className="table-responsive border radius-8 bg-white shadow-sm">
          <table className="table bordered-table sm-table mb-0">
            <thead>
              <tr style={{ background: "linear-gradient(135deg, #bb0007, #ed1c24)" }}>
                <th scope="col" className="text-white fw-bold py-12 px-16 text-nowrap">S.No</th>
                <th scope="col" className="text-white fw-bold py-12 text-nowrap">Candidate Name</th>
                <th scope="col" className="text-white fw-bold py-12 text-nowrap">Father/Husband Name</th>
                <th scope="col" className="text-white fw-bold py-12 text-nowrap">DOB</th>
                <th scope="col" className="text-white fw-bold py-12 text-nowrap">Gender</th>
                <th scope="col" className="text-white fw-bold py-12 text-nowrap">Email</th>
                <th scope="col" className="text-white fw-bold py-12 text-nowrap">Contact No</th>
                <th scope="col" className="text-white fw-bold py-12 text-nowrap">Qualification</th>
                <th scope="col" className="text-white fw-bold py-12 text-nowrap">Experience</th>
                <th scope="col" className="text-white fw-bold py-12 text-nowrap">Expected CTC</th>
                <th scope="col" className="text-white fw-bold py-12 text-nowrap">Applied Date</th>
                <th scope="col" className="text-white fw-bold py-12 text-center text-nowrap">PDF</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="12" className="text-center py-50">
                    <div className="spinner-border text-danger" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </td>
                </tr>
              ) : filteredEnquiries.length > 0 ? (
                filteredEnquiries.map((enq, index) => (
                  <tr key={enq._id || enq.id}>
                    <td>{index + 1}</td>
                    <td className="text-nowrap fw-semibold text-secondary-light">{enq.fullName}</td>
                    <td className="text-nowrap text-secondary-light">{enq.fatherOrHusbandName || "N/A"}</td>
                    <td className="text-nowrap text-secondary-light">
                        {enq.dob ? (enq.dob.includes('T') ? new Date(enq.dob).toLocaleDateString("en-GB") : enq.dob) : "N/A"}
                    </td>
                    <td className="text-nowrap text-secondary-light">{enq.gender || "N/A"}</td>
                    <td className="text-nowrap text-secondary-light">{enq.email}</td>
                    <td className="text-nowrap text-secondary-light">{enq.mobileNo}</td>
                    <td className="text-nowrap text-secondary-light">{enq.qualification || "N/A"}</td>
                    <td className="text-nowrap text-secondary-light">{enq.experience || "N/A"}</td>
                    <td className="text-nowrap">
                        <span className="text-success-600 fw-bold">
                            ₹ {formatPrice(enq.expectedSalary)}
                        </span>
                    </td>
                    <td className="text-nowrap text-secondary-light">{new Date(enq.createdAt).toLocaleDateString("en-GB")}</td>
                    <td className="text-center">
                      {enq.resume ? (
                        hasPermission("careers", "view") ? (
                          <a 
                            href={getImageUrl(enq.resume)} 
                            target="_blank" 
                            rel="noreferrer" 
                            className="text-danger-600 hover-text-danger-800"
                          >
                            <Icon icon="solar:file-download-bold" className="text-2xl" />
                          </a>
                        ) : (
                          <Icon icon="solar:file-download-bold" className="text-2xl text-secondary-light opacity-50" title="Permission Denied" />
                        )
                      ) : (
                        <span className="text-secondary-light text-xs italic">N/A</span>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="12" className="text-center py-50 text-secondary-light">
                    <Icon icon="solar:user-block-bold" className="text-4xl mb-2 opacity-25" />
                    <p className="mb-0">No enquiries found for this position yet.</p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CareerEnquiryLayer;
